import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { KopijaVerifikacijeComponent } from './kopija-verifikacije.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [KopijaVerifikacijeComponent],
  entryComponents: [KopijaVerifikacijeComponent],
  exports: [KopijaVerifikacijeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class KopijaVerifikacijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/kopija-verifikacije/kopija-verifikacije.module.ts